import { inject, Injectable } from '@angular/core';
import { ApiService } from '../../../../core/services/ApiService';
import { map, Observable, tap } from 'rxjs';
import { IResponse } from '../../../../core/interfaces/IResponse';
import { INoDataResponse } from '../../../../core/interfaces/INoDataResponse';
import { SafeActions } from '../enums/SafeActions';
import { ISafeInfo } from '../interfaces/ISafeInfo';
import { StatisticsService } from '../../../statistics/core/services/StatisticsService';

@Injectable({
  providedIn: 'root'
})
export class SafesService {

  private readonly _basePath = '/terminals';
  private readonly _apiService = inject(ApiService);
  private readonly _statisticsService = inject(StatisticsService);

  public getSafeInfo(safeNumber: number): Observable<IResponse<ISafeInfo>> {
    return this._apiService.get(`${this._basePath}/safe-info?safeNr=${safeNumber}`);
  }

  public getSafes(): Observable<IResponse<ISafeInfo[]>> {
    return this._apiService.get(`${this._basePath}/safes`)
      .pipe(
        map((res: IResponse<ISafeInfo[]>) => {
          res.data = res.data.map(x => {
            return {
              ...x,
              name: x.safeNr.toString()
            };
          });

          return res;
        })
      );
  }

  public makeSafeAction(
    safeId: number,
    amount: number,
    isDifferenceOpening: boolean,
    action: SafeActions,
    remark = '',
    datevId: number = null,
  ): Observable<INoDataResponse> {
    return this._apiService.post(
      `${this._basePath}/safe-action`,
      {
        safeId,
        amount,
        isDifferenceOpening,
        remark,
        action,
        datevId
      }
    )
      .pipe(
        tap(() => this._statisticsService.getSessionStatistics().subscribe())
      );
  }
}
